import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from '@environments/environment';
import { OrganizationTin } from '@models/organizationTin.model';

@Injectable({
  providedIn: 'root'
})
export class TaxIdentificationNumberDetailsService {
  private apiUrl = environment.apiUrl;
    
  createOrganizationTIN(details: any): Observable<any> {
    return this.http.post<OrganizationTin>(`${this.apiUrl}/Organization/TIN`, details);
  }

  updateOrganizationTIN(details: any): Observable<any> {
    return this.http.put<OrganizationTin>(`${this.apiUrl}/Organization/TIN`, details);
  }

  deleteOrganizationTIN(id: any): Observable<any> {
    return this.http.delete<OrganizationTin>(`${this.apiUrl}/Organization/TIN/${id}`);
  }
  constructor(private http: HttpClient) { }
}
